import React from "react";
import PropTypes from "prop-types";
import { Flex, Icon, Popover, Small, StyledLink } from "orcs-design-system";

/** Icon + text row item matching ProfileHeader stats styling. */
const HeaderMetaItem = ({
  icon,
  label,
  popoverContent,
  to,
  title,
  "data-testid": dataTestId,
}) => {
  const text = <Small color="subText">{label}</Small>;
  const content = to ? (
    <StyledLink to={to} aria-label={title || label}>
      {text}
    </StyledLink>
  ) : (
    text
  );

  const body = (
    <Flex alignItems="center" gap="s" data-testid={dataTestId} title={title}>
      <Icon icon={icon} color="subText" />
      {content}
    </Flex>
  );

  if (!popoverContent) {
    return body;
  }

  return (
    <Popover direction="top" width="fit-content" text={popoverContent}>
      {body}
    </Popover>
  );
};

HeaderMetaItem.propTypes = {
  icon: PropTypes.array.isRequired,
  label: PropTypes.node.isRequired,
  popoverContent: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  to: PropTypes.string,
  title: PropTypes.string,
  "data-testid": PropTypes.string,
};

export default HeaderMetaItem;
